<mat-form-field class="mat-form-field-fluid">
    <mat-label [attr.data-test-id]="testId + '-label'">Social Security Number</mat-label>
    <input matInput [type]="hide ? 'password' : 'tel'" [(ngModel)]="value" maxlength="11"
           autocomplete="off" [required]="required" [disabled]="disabled"
           (ngModelChange)="onChangeSSN()" #ssn="ngModel" [attr.data-test-id]="testId + '-input'" [name]="name" [id]="id" inputmode="numeric" [readonly]="readonly">
    <span matSuffix (click)="hide = !hide" class="eye-icon" [attr.data-test-id]="testId + '-visibility-toggle'">
        <sm-icon [name]="hide ? 'eye-off' : 'eye'" [width]="24" [height]="24"></sm-icon>
    </span>
    <mat-error *ngIf="ssn.hasError('required')" [attr.data-test-id]="testId + '.required-error'">Please enter the Social Security number.</mat-error>
    <mat-error *ngIf="ssn.hasError('invalid')" [attr.data-test-id]="testId + '.invalid-error'">Please enter a valid Social Security number.</mat-error>
</mat-form-field>

